// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';
import type { IFileInfoDto } from './IFileInfoDto';
import {
    IFileInfoDtoFromJSON,
    IFileInfoDtoFromJSONTyped,
    IFileInfoDtoToJSON,
    IFileInfoDtoToJSONTyped,
} from './IFileInfoDto';

/**
 * 
 * @export
 * @interface IPageFileInfoDto
 */
export interface IPageFileInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IPageFileInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageFileInfoDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageFileInfoDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IFileInfoDto>}
     * @memberof IPageFileInfoDto
     */
    content?: Array<IFileInfoDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageFileInfoDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageFileInfoDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageFileInfoDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageFileInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageFileInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageFileInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageFileInfoDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageFileInfoDto interface.
 */
export function instanceOfIPageFileInfoDto(value: object): value is IPageFileInfoDto {
    return true;
}

export function IPageFileInfoDtoFromJSON(json: any): IPageFileInfoDto {
    return IPageFileInfoDtoFromJSONTyped(json, false);
}

export function IPageFileInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageFileInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IFileInfoDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageFileInfoDtoToJSON(json: any): IPageFileInfoDto {
    return IPageFileInfoDtoToJSONTyped(json, false);
}

export function IPageFileInfoDtoToJSONTyped(value?: IPageFileInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IFileInfoDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

